export default __webpack_public_path__ + "static/media/img_vision_06_3_m.e2544170.png";